import React from 'react'
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const Cancel = () => {
  const { pathname } = useLocation();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="max-w-4xl mx-auto p-4 min-h-screen py-10 md:py-20 text-justify">

    <h1 className="text-2xl font-bold mb-4 text-center  py-10">Cancellation Policy</h1>
    <h1 className=" font-bold mb-4">Cancellation Policy</h1>
    <p className="mb-4">
    There may be certain orders that we are unable to accept and must cancel. Carizo.in reserves the right, at its sole discretion, to refuse or cancel any order for any reason whatsoever. Some situations that may result in Your order being cancelled include, without limitation, non-availability of the product or quantities ordered by You, non- availability of the service, inaccuracies or errors in pricing information, or problems identified by CYNOR INDIA credit and fraud avoidance. We may also require additional verifications or information before accepting any order. We will intimate you if all or any portion of your order is cancelled or if additional information is required to accept your order. If your order is cancelled after your card has been charged, the said amount will be reversed back to your account.
    </p>
   

    <p className="mb-4 font-bold">Cancellation by the User:</p>
  <p>In case of requests for order cancellations, carizo.in reserves the right to accept or reject requests for order cancellations for any reason whatsoever. As part of usual business practice, if we receive a cancellation notice and the order has not been processed/ approved by us, we shall cancel the order and refund the entire amount to you within a reasonable period of time. we will not be able to cancel orders that have already been processed.</p>
  <p>Decision taken by carizo.in regarding cancellation or refusal to cancellation of a order shall be final and binding upon the user.</p>
        
        </div>
  )
}

export default Cancel